//登録フロー：FB認証ページ /newflow1
import React, {Component} from 'react';
import Header from './header'
import Footer from './footer'
import {Link, browserHistory} from 'react-router'
import users from './store/user'
import './css/newflow1.css';
import {login, checkLogin, Facebookregister} from './firebase'

export default class newflow1 extends Component {
  loginStart(e){
    //新規登録フラグ
    const isRegist = true;
    login(function() {
      if(users.getMyUser().uid) {
        Facebookregister(users.getMyUser(), function(noEmail){
          if(noEmail) {
            browserHistory.push("/email_register");
          } else {
            browserHistory.push("/newflow3");
          }
        });
      }
    }, isRegist)
  }

  emailLoginStart(e) {
    e.preventDefault();
    browserHistory.push('/email_register2');
  }

  // onload
  componentDidMount() {
    // ログインチェック
    checkLogin()
  }

  render() {
      return (
    <div id="wrapper">
      <div id="" className="wrapper-lp wrapper-newflow1">
        <Header/>
        <div className="webWrap">
          <div className="wrapCover">
            <div className="wrapCover__contentBlock clearfix">
              <div className="content-top">
                <div className="block-newflow1">
                  <h2 className="title">Sign up</h2>
                  <img className="title_icon" src="/img/common/m-card@2x.png" alt="" />
                  <p className="subtitle">アカウント登録をしよう！</p>
                  <div className="notice">
                    <p>MyRateは利用者様の情報の証明書となるため、利用者様の本人確認をしています。</p>
                  </div>
                  <div className="btnAction">
                    <Link className="btn-connect fb-button" onClick={(e) => {this.loginStart(e)}}>Facebookで登録する</Link>
                    <Link className="btn-connect mail-button" onClick={(e) => {this.emailLoginStart(e)}}>メールアドレスで登録する</Link>
                  </div>
                  
                </div>
              </div>
            </div>
            <Footer/>
          </div>
        </div>
      </div>
    </div>
      )

    }
}



// WEBPACK FOOTER //
// ./src/newflow1.js